import Api, { baseURL, requestOptionsGET, requestOptionsPOST, requestOptionsPUT, requestOptionsDELETE } from '../api';
import newFetch from '../utils/newFetch';

const state = {
  manualBoarding: [],
  steps: [],
  stepId: null,
  paginate: {
    pageNumber: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0
  },
  filters: {
    CreatedAtStart: null,
    CreatedAtEnd: null,
    NumberProcess: null,
    ResponsibleUserId: null,
    StepId: null
  },
  paginateXmlsNfe: {
    pageNumber: 1,
    pageSize: 5,
    totalRecords: 0,
    totalPages: 0
  },
  filterByStatusId: null
};

const getters = {
  getManualBoarding: (state) => state.manualBoarding,
  getSteps: (state) => state.steps,
  getStepId: (state) => state.stepId,
  getFilters: ({ paginate, filters }) => {
    return (
      `?PageSize=${paginate.pageSize}&PageNumber=${paginate.pageNumber}` +
      (filters.CreatedAtStart ? `&CreatedAtStart=${filters.CreatedAtStart}` : '') +
      (filters.CreatedAtEnd ? `&CreatedAtEnd=${filters.CreatedAtEnd}` : '') +
      (filters.ResponsibleUserId ? `&ResponsibleUserId=${filters.ResponsibleUserId}` : '') +
      (filters.StepId ? `&StepsId=${filters.StepId}` : '') +
      (filters.NumberProcess ? `&ManualBoardingImportNumber=${filters.NumberProcess}` : '')
    );
  },
  getFilterByStatusId: ({ paginateXmlsNfe, filterByStatusId }) => {
    return (
      `&PageSize=${paginateXmlsNfe.pageSize}&PageNumber=${paginateXmlsNfe.pageNumber}` +
      (filterByStatusId ? `&StatusId=${filterByStatusId}` : '')
    );
  }
};

const mutations = {
  setStepId(state, payload) {
    state.stepId = payload;
  },
  setManualBoarding(state, payload) {
    state.manualBoarding = payload;
  },
  setItemPerPage(state, payload) {
    state.paginate.pageSize = payload;
  },
  setPageNumber(state, payload) {
    state.paginate.pageNumber = payload;
  },
  setTotalPages(state, payload) {
    state.paginate.totalPages = payload;
  },
  setTotalRecords(state, payload) {
    state.paginate.totalRecords = payload;
  },
  setFilterCreatedAtStart(state, payload) {
    state.filters.CreatedAtStart = payload;
  },
  setFilterCreatedAtEnd(state, payload) {
    state.filters.CreatedAtEnd = payload;
  },
  setFilterNumberProcess(state, payload) {
    state.filters.NumberProcess = payload;
  },
  setFilterResponsibleUserId(state, payload) {
    state.filters.ResponsibleUserId = payload;
  },
  setFilterStepId(state, payload) {
    state.filters.StepId = payload;
  },
  setSteps(state, payload) {
    state.steps = payload;
  },
  setNfeXmlFilterStatusId(state, payload) {
    state.filterByStatusId = payload;
  }
};

const actions = {
  fetchManualBoarding(context) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getAllManualBoarding + context.getters.getFilters,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data, totalPages, totalRecords }) => {
          context.commit('setManualBoarding', data);

          context.commit('setTotalPages', totalPages);
          context.commit('setTotalRecords', totalRecords);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  createManualBoardingImport() {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.createManualBoardingImport, requestOptionsPOST(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  cancelManualBoardingImport(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.deleteManualBoardingImport + id, requestOptionsDELETE(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
          return data;
        })
        .catch((err) => {
          reject(err);
          return err;
        });
    });
  },
  startManualBoardingImport(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.startManualBoardingImport + id, requestOptionsPOST(localStorage.getItem('accessToken')))
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchManualBoardingByID(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getByIdManualBoardingImport + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  fetchSummarySteps(context) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getSummaryManualBoardingSteps, requestOptionsGET(localStorage.getItem('accessToken')))
        .then((data) => {
          context.commit('setSteps', data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },

  updateManualBoardingSteps(_, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.updateManualBoardingSteps + model.id + `&stepId=` + model.step,
        requestOptionsPUT(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  confirmImportsNfes(_, model) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.confirmImportsNfes + model.processId,
        requestOptionsPOST(localStorage.getItem('accessToken'), { unusedNfesIds: model.unusedNfes || [] })
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
